module.exports = __webpack_public_path__ + "static/media/tanakh.16fd486b.svg";